module.exports = __webpack_public_path__ + "img/banner-pulih.97bb82f1.png";